<template>
  <div>
    <div class="bg-primary brx-8 p-3">
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-center text-white text-center text-md-start">
        <div class="d-flex flex-column flex-md-row align-items-center">
          <div class="gradient-border m-2 m-md-0">
            <img :src="generateFullUrlWithToken(profile.profile_picture)" class="rounded-circle hpx-80"
              @error="$event.target.src = '/img/user_default_pic.png'" alt="Profile" />
          </div>
          <div class="d-flex flex-column justify-content-start ms-md-3 text-center text-md-left mx-md-3">
            <h5 class="m-0 text-white fw-700 mt-2 mt-md-0" :style="`color: ${getGenderColor(profile.gender)}`">
              {{ profile._title | toTitleCase }}
              {{ profile.first_name | toTitleCase }}
              {{ profile.surname | toTitleCase }}
            </h5>
            <p class="mb-0" v-if="profile.candidateTypeName">
              {{ profile.candidateTypeName }}
            </p>
          </div>
        </div>

        <div class="mt-2 mt-md-0">
          <span>Candidate ID : </span>
          <span class="fw-bold">{{ profile.display_uid }}</span>
        </div>
      </div>

      <!-- <div v-if="enableAddScratchPad" class="d-flex justify-content-end align-items-center m-2">
        <span class="bg-secondary text-white cursor-pointer-hover-gradient px-2 py-1 br-50" v-c-tooltip="{
          content: 'Add to Scratch Pad',
          appendToBody: true,
          placement: 'bottom',
        }" @click="addToScratch">
          <small>Add to Scratch Pad</small>
          <i class="fa-solid fa-circle-plus fs-14 ml-2"></i>
        </span>
         <div class="ml-3">
          <CButton class="btn br-12">
            <i class="fa-solid fa-pen-to-square text-white"></i>
          </CButton>
        </div> 
      </div> -->
    </div>

    <div class="p-3">
      <p style="font-size: 15px !important;">
        Discover thrilling job opportunities and boost your career. Regularly
        check our platform for updates on your applications and new job alerts!
      </p>
      <div class="row">
        <div v-for="(field, index) in profileFields" :key="index" class="col-12 col-lg-6">
          <div class="px-3 pb-3 pt-0 rounded bg-white">
            <div class="row align-items-center brb-blue-light pb-2">
              <div class="col-12 col-lg-4 d-flex align-items-center">
                <div
                  class="bg-primary-light d-inline-flex justify-content-center align-items-center rounded-circle min-hpx-30 min-wpx-30 mr-1">
                  <i :class="field.icon" class="text-primary"></i>
                </div>
                <span>{{ field.label }}</span>
              </div>
              <div v-if="['Web'].includes(field.label)"
                class="col-12 col-lg-8 bold text-secondary text-end overflow-hidden text-truncate text-wrap px-md-5 px-lg-0">
                <a v-if="field.value" target="_blank" :href="`https://${field.value}`">
                  {{ field.value }}
                </a>
                <span v-else>--</span>
              </div>
              <div v-else
                class="col-12 col-lg-8 bold text-secondary text-end overflow-hidden text-truncate text-wrap px-5 px-lg-0">
                {{ field.value || "--" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PopupModal v-if="popupModal.isShowPopup" :modalTitle="popupModal.modalTitle" :modalColor="popupModal.modalColor"
      :modalContent="popupModal.modalContent" :modalLabel="popupModal.modalLabel" :isShowPopup="popupModal.isShowPopup"
      :popupModalCallBack="popupModalCallBack" :modalJob="popupModal.modalJob"
      :modalReasonType="popupModal.modalReasonType" />
    <PreviewModal v-if="previewModal.isShowPopup" :modalTitle="previewModal.modalTitle"
      :modalColor="previewModal.modalColor" :isShowPopup="previewModal.isShowPopup" :buttons="previewModal.buttons"
      :modalCallBack="modalCallBack" :isPreview="previewModal.isPreview" :iframe="iframe" :size="previewModal.size"
      :closeOnBackdrop="previewModal.closeOnBackdrop" />
    <CandidateFrontsheet v-if="frontSheetModal.isShowPopup" :isShowPopup="frontSheetModal.isShowPopup"
      @modalCallBack="frontSheetModalCallBack" :candidateDetail="frontSheetModal.candidate"
      :jobDetail="frontSheetModal.job" :frontSheetInfo="frontSheetModal.frontSheetInfo"
      :frontSheets="frontSheetModal.comments" />
    <Modal v-if="reqAgencyModal.isShowPopup" :modalTitle="reqAgencyModal.modalTitle"
      :modalColor="reqAgencyModal.modalColor" :modalContent="reqAgencyModal.modalContent"
      :isShowPopup="reqAgencyModal.isShowPopup" :buttons="reqAgencyModal.buttons"
      :modalCallBack="reqAgencyModalCallBack" :closeOnBackdrop="false" />
    <ScratchPadModal v-if="scratchpad.isShowPopup" :todo="scratchpad.todo" :isShowPopup="scratchpad.isShowPopup"
      @modalCallBack="scratchPadModalCallBack" />
  </div>
</template>
<script>
import _ from "lodash";
import { getScope, Role, generateFullUrlWithToken } from "@/helpers/helper";
import { mapActions, mapGetters } from "vuex";
import pdf from "vue-pdf";
import { BASE_URL } from "@/service_urls";
import isJobSupplier from "@/mixins/isJobSupplier";
import PreviewModal from "@/components/reusable/PreviewModal";
import PopupModal from "@/components/reusable/PopupModal";
import Modal from "@/components/reusable/Modal";
import CandidateFrontsheet from "@/containers/Frontsheet/CandidateFrontsheet";
import ScratchPadModal from "@/containers/Dashboard/RecruiterDashBoard/ScratchPadModal";

export default {
  mixins: [isJobSupplier],
  props: {
    profile: {
      type: Object,
      default: {},
    },
    agencyCVDocument: {
      type: Array,
      default: () => [],
    },
    resumeDocument: {
      type: Array,
      default: () => [],
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    enableAddScratchPad: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Modal,
    PreviewModal,
    PopupModal,
    CandidateFrontsheet,
    ScratchPadModal,
  },
  data() {
    return {
      currentUserRole: getScope(),
      Role,
      iframe: {
        src: "",
        loaded: false,
        isImg: false,
        pdf: {
          ispdf: false,
          src: "",
          numPages: undefined,
          addContentClasses: "",
        },
      },
      previewModal: {
        modalColor: "primary",
        modalTitle: "Document Preview",
        isShowPopup: false,
        buttons: ["OK"],
        isPreview: false,
        size: "lg",
        closeOnBackdrop: false,
      },
      frontSheetModal: {
        isShowPopup: false,
        candidate: null,
        job: null,
        frontSheetInfo: null,
        comments: [],
      },
      reqAgencyModal: {
        isShowPopup: false,
        modalTitle: "Request Agency CV",
        modalContent:
          "Please confirm you would like to request the CV for this candidate?",
        modalColor: "primary",
        buttons: ["No", "Yes"],
      },
      popupModal: {
        modalColor: "",
        modalTitle: "",
        modalContent: "",
        modalLabel: "Select Reason Code",
        isShowPopup: false,
        modalJob: "",
        modalReasonType: "",
      },
      scratchpad: {
        isShowPopup: false,
        toDo: {},
      },
      generateFullUrlWithToken,
      profileFields: [
        {
          icon:
            this.profile.genderName === "Male"
              ? "fa-solid fa-mars"
              : "fa-solid fa-venus",
          label: "Gender",
          value: this.profile.genderName,
        },
        {
          icon: "fa-solid fa-location-dot",
          label: "Location",
          value: this.profile.current_country?.country_name || '---',
        },
        {
          icon: "fa-solid fa-envelope",
          label: "Email",
          value: this.profile.email,
        },
        {
          icon: "fa-solid fa-calendar-days",
          label: "Age",
          value: `${this.profile.age} Years`,
        },
        {
          icon: "fa-solid fa-phone",
          label: "Phone",
          value: this.profile.phone,
        },
        {
          icon: "fa-brands fa-whatsapp",
          label: "Whatsapp",
          value: this.profile.whatsappNumber,
        },

        {
          icon: "fa-solid fa-flag",
          label: "Nationality",
          value: this.profile.nationalityName,
        },
        {
          icon: "fa-solid fa-globe",
          label: "Web",
          value: this.profile.personal_website || '---',
        },
        {
          icon: "fa-regular fa-registered",
          label: "Reg.on",
          value: this.profile.createdOnDate,
        },
        {
          icon: "fa-solid fa-file-import",
          label: "Last Login",
          value: this.profile.lastLoginDate,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "isCandidateSupplierFromAccessToken",
      "getGenderColor",
      "getUserId",
      "getOrgIDFromAccessToken",
      "getAgencyCVRequest",
      "getCustomerId",
      "getUserId",
      "getIsParentUser",
      "isUKMainAgency",
      "isHeadlessClient",
      "getJobCandidateCount",
    ]),
    isPrivate() {
      return this.profile?.is_private || false;
    },
    isAgencyBadge() {
      return (
        (this.profile.agency_contact_id &&
          this.profile.organisation_name &&
          this.isUKMainAgency &&
          this.currentUserRole !== this.Role.systemAdmin) ||
        false
      );
    },
    isOrgBadge() {
      return (
        (this.profile.organisation_id != this.getOrgIDFromAccessToken &&
          this.getIsParentUser) ||
        false
      );
    },
    isAgencyCVReqPending() {
      return (
        this.getAgencyCVRequest.filter(
          ({ candidate_id, date_uploaded, req_org_id }) =>
            candidate_id === this.profile?.candidate_uid &&
            date_uploaded == null &&
            req_org_id === this.getOrgIDFromAccessToken
        ).length > 0 || false
      );
    },
    isCandidateRole() {
      return (
        this.currentUserRole === Role.customerCandidate ||
        this.currentUserRole === Role.systemCandidate
      );
    },
    latestResume() {
      return _.maxBy(this.resumeDocument, "version_no");
    },
    latestAgencyCV() {
      return _.maxBy(this.agencyCVDocument, "version_no");
    },
    inProcessCount() {
      return (
        (this.getJobCandidateCount && this.getJobCandidateCount[4]) || null
      );
    },
    isShowPrcessBadge() {
      return !this.isCandidateRole && !this.isCustomerUserRole;
    },
    isCustomerUserRole() {
      return this.currentUserRole === Role.customerUser;
    },
    toolTip() {
      return this.profile.shared_organisations.map((i) => i.name).join(", ");
    },
  },
  methods: {
    ...mapActions([
      "createAgencyCVRequest",
      "postScratchPad",
      "deleteCandidate",
      "deactivateCandidate",
      "restoreCandidate",
      "reactivateCandidate",
      "getCandidateDetails",
    ]),
    showPreview(data) {
      const { link } = data;
      // const _baseUrl = BASE_URL;
      // const _base_domain = _baseUrl.substring(0, _baseUrl.indexOf("/api"));
      return generateFullUrlWithToken(link);
    },
    preview(data) {
      data.link_to_document = this.showPreview(data);
      var _baseUrl = BASE_URL;
      var _base_domain = "https://" + window.location.host;
      this.iframe.url = data.link_to_document;
      if (["PNG", "JPG", "JPEG", "GIF"].includes(data?.document_ext)) {
        this.iframe.loaded = false;
        this.iframe.ispdf = false;
        this.iframe.isImg = true;
        this.iframe.src = data.link_to_document;
        this.previewModal.isPreview = true;
        this.previewModal.isShowPopup = true;
      } else if (data?.document_ext === "PDF") {
        this.iframe.isImg = false;
        this.iframe.loaded = false;
        this.iframe.pdf.ispdf = true;
        this.iframe.pdf.src = pdf.createLoadingTask(data.link_to_document);
        setTimeout(() => {
          this.iframe.pdf.src.promise.then((pdf) => {
            this.iframe.pdf.numPages = pdf.numPages;
          });
        }, 100);
        this.previewModal.isPreview = true;
        this.previewModal.isShowPopup = true;
      } else if (
        ["TXT", "EPS", "TIF", "TIFF", "RAW"].includes(data?.document_ext)
      ) {
        this.showToast({
          class: "bg-danger text-white",
          message: "The selected file type is not available for Preview.",
        });
        this.iframe.src = "";
        this.iframe.loaded = false;
        this.iframe.isImg = false;
        this.iframe.pdf.ispdf = false;
        this.previewModal.isPreview = false;
        this.previewModal.isShowPopup = false;
      } else {
        this.iframe.isImg = false;
        this.iframe.ispdf = false;
        this.iframe.loaded = true;
        this.iframe.src =
          "https://view.officeapps.live.com/op/embed.aspx?src=" +
          data.link_to_document;
        this.previewModal.isPreview = true;
        this.previewModal.isShowPopup = true;
      }
    },
    openFrontSheet() {
      this.frontSheetModal.candidate = this.profile;
      this.frontSheetModal.isShowPopup = true;
      this.frontSheetModal.comments = [];
    },
    frontSheetModalCallBack(action, payload) {
      this.frontSheetModal.isShowPopup = false;
    },
    modalCallBack(action) {
      this.previewModal.isPreview = false;
      this.previewModal.isShowPopup = false;
      this.iframe.src = "";
      this.iframe.loaded = false;
      this.iframe.isImg = false;
      this.iframe.pdf.ispdf = false;
    },
    candidateState(event) {
      let name = event.currentTarget.name;
      let cname = {
        delete: "Delete",
        deactivate: "Deactivate",
      };
      this.popupModal.modalReasonType = name.toUpperCase();
      this.popupModal.modalTitle = `${name} Candidate`;
      this.popupModal.modalContent = `Are you sure to ${name.toLowerCase()} the candidate? If Yes please select an appropriate reason..`;
      this.popupModal.isShowPopup = true;
      if (name === cname.delete || name === cname.deactivate) {
        this.popupModal.modalColor = "danger";
      } else {
        this.popupModal.modalColor = "primary";
      }
    },
    popupModalCallBack(action, value) {
      let appendAction;
      const { modalTitle } = this.popupModal;
      const _action = {
        confirm: "Confirm",
        cancel: "Cancel",
        deleteCandidate: "Delete Candidate",
        deactivateCandidate: "Deactivate Candidate",
        restoreCandidate: "Restore Candidate",
        reactivateCandidate: "Reactivate Candidate",
      };
      if (action === _action.confirm) {
        let payload = {
          candidate_id: this.profile.candidate_uid,
          reason_id: value.reason_id,
          comments: value.comments,
          customer_uid: this.profile?.customer_uid,
        };
        //Delete
        if (modalTitle === _action.deleteCandidate) {
          appendAction = this.deleteCandidate(payload);
        }
        //Deactivate
        else if (modalTitle === _action.deactivateCandidate) {
          appendAction = this.deactivateCandidate(payload);
        }
        //Restore
        else if (modalTitle === _action.restoreCandidate) {
          appendAction = this.restoreCandidate(payload);
        }
        //Reactivate
        else if (modalTitle === _action.reactivateCandidate) {
          appendAction = this.reactivateCandidate(payload);
        }
        Promise.all([appendAction]).then((res) => {
          this.getCandidateDetails(this.$route.params.id);
        });
      }
      this.popupModal.isShowPopup = false;
    },
    openReqAgencyModal() {
      this.reqAgencyModal.isShowPopup = true;
      // this.reqAgencyModal.modalContent = `Please confirm you would like to request the CV for candidate - ${this.profile.full_name}?`
    },
    reqAgencyModalCallBack(action) {
      if (action === "Yes") {
        //Request Agency CV
        const payload = {
          req_org_id: this.getOrgIDFromAccessToken,
          req_user_id: this.getUserId,
          candidate_id: this.profile?.candidate_uid,
        };
        this.createAgencyCVRequest(payload);
      }
      this.reqAgencyModal["isShowPopup"] = false;
    },
    addToScratch() {
      const name = `<a href='/candidate/${this.profile.candidate_uid
        }'>${this.toTitleCase(this.profile.first_name)} ${this.toTitleCase(
          this.profile.surname
        )} (ID-${this.profile.display_uid})</a>`;
      this.scratchpad.todo = {
        title: `Candidate - ${this.toTitleCase(
          this.profile.first_name
        )} ${this.toTitleCase(this.profile.surname)} (ID-${this.profile.display_uid
          })`,
        description: `<p>Please review candidate ${name}</p>`,
      };
      this.scratchpad.isShowPopup = true;
    },
    scratchPadModalCallBack(action, payload) {
      if (action && payload) {
        this.postScratchPad(payload);
      }
      this.scratchpad.isShowPopup = false;
      this.scratchpad.todo = null;
    },
    toTitleCase(str) {
      if (str) return _.startCase(str);
      return str;
    },
  },
  filters: {
    toTitleCase(str) {
      if (str) return _.startCase(str);
      return str;
    },
  },
};
</script>
<style lang="scss" scoped>
.fs-14 {
  font-size: 14px !important;
}

// .cand-info-img {
//   display: inline-block;
//   padding: 4px; // Border width
//   border-radius: 50%;
//   background: linear-gradient(135deg, $primary-gradient1, $primary-gradient2, $primary-gradient3);

//   img {
//     display: block;
//     width: 100px; // Set your desired size
//     height: 100px;
//     border-radius: 50%;
//     object-fit: cover;
//     background-color: #fff; // Optional, fallback inside circle
//   }
// }</style>
